<template>
  <!-- createList dialog -->
  <!-- <el-dialog title="新規メッセージ" :visible.sync="newmessage_drawer" width="640px" top="10vh"> -->
  <div class="newmessage-wrap" :class="minimize ? 'minimize' : ''">
    <div class="list-create">
      <div class="newmessage-title" :class="minimize ? 'minimize' : ''">
        新規メッセージ
        <div class="flex-space"></div>
        <div class="newmessage-button" @click="minimizeWindow()">
          <font-awesome-icon :icon="['fal', 'minus']" />
        </div>
        <div class="newmessage-button" @click="closeNewmessage()">
          <font-awesome-icon :icon="['fal', 'times']" />
        </div>
      </div>
      <div class="newmessage-box" style="margin-bottom: 0px">
        <div class="newmessage-subtitle">送信元</div>
        <div class="newmessage-recipient-wrap" style="overflow-x: hidden">
          <div class="newmessage-recipient-box">
            <connectAccount
              @isIgAccountLoading="isIgAccountLoading"
              @error-message-check="handleConnectAccountError"
            />
          </div>
          <span
            v-if="ig_selected.login_required"
            class="router-link"
            style="margin-left: 10px; font-size: 11px; font-weight: 700"
            @click="toConnectSetting()"
            >アカウントを再連携する</span
          >
        </div>
        <div class="newmessage-subtitle">送信先 ({{ recipient.length }}人)</div>
        <div v-if="recipient.length == 0" class="newmessage-recipient-wrap">
          <span class="newmessage-warning-icon">
            <font-awesome-icon :icon="['fas', 'exclamation-triangle']" />
          </span>
          リストより送信先を選択してください
        </div>
        <div class="newmessage-recipient-wrap" id="recipient-wrap">
          <div
            v-for="(influencer, influencer_index) in recipient"
            :key="influencer.ig_id"
            class="newmessage-recipient-box pointer"
            :class="[influencer_index == recipient.length - 1 ? 'last' : '', influencer_index == preview_index && preview_drawer ? 'preview' : '']"
            @click="openPreview(influencer_index)"
          >
            <el-image :src="influencer.profile_picture_url" class="request-pr-form-suggest-image">
              <div slot="error" class="data-table-profile-noimg">
                NO
                <br />IMAGE
              </div>
            </el-image>
            <div>
              <div class="newmessage-recipient-namebox">
                {{ influencer.account_name }}
                <img
                  src="../../assets/badge.png"
                  style="width: 10px; height: 10px; margin-left: 3px"
                  v-show="influencer.badge == '1'" />
              </div>
            </div>
            <div class="flex-space"></div>
            <div>
              <font-awesome-icon
               :icon="['fal', 'times']"
               @click.stop="deleteInfluencer(influencer_index, influencer.ig_id)"
               class="recipient-close-button" />
            </div>
            <div class="recipient-preview-mark" v-show="influencer_index == preview_index && preview_drawer">プレビュー中</div>
          </div>
        </div>
      </div>
      <!-- <div>
          <div>{{pos_y}}行目・{{pos_x}}列目</div>
        </div>-->
      <div class="newmessage-box border" style="margin-bottom: 8px;">
        <div
          contenteditable="true"
          class="inbox-phrase-input scrollbar-a"
          v-html="html"
          @click="sync()"
          @focus="sync()"
          @input="sync()"
          @keydown.right.exact="sync()"
          @keydown.left.exact="sync()"
          @keydown.down.exact="sync()"
          @keydown.up.exact="sync()"
          @keydown.enter="enter()"
          @paste.prevent
          @paste="paste($event)"
          id="phrase"
        ></div>
        <div class="inbox-phrase-params-wrap">
          <div class="inbox-phrase-insertbutton">
            <el-tooltip>
              <div slot="content">テンプレート</div>
              <font-awesome-icon
                class="pointer"
                :icon="['fal', 'comment-alt-dots']"
                @click="phrase_select_drawer = true"
              />
            </el-tooltip>
            <phraseSelect
              v-if="phrase_select_drawer"
              :phrase_select_drawer.sync="phrase_select_drawer"
              @insertTemplete="insertTemplete"
            />
            <div
              class="phrase-select-overlay"
              v-if="phrase_select_drawer"
              @click="phrase_select_drawer = false"
            ></div>
          </div>
          <div style="position: relative">
            <el-dropdown trigger="click">
              <div class="inbox-phrase-params pointer">
                <font-awesome-icon
                  :icon="['fas', 'plus-circle']"
                  style="margin-right: 3px"
                />
                <span class="newmessage-insert-item"
                  >パーソナライズ項目を挿入</span
                >
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-tooltip placement="right">
                  <div slot="content">
                    インフルエンサーの名前を挿入します。
                  </div>
                  <el-dropdown-item @click.native="InsertParams(name_word)">
                    <span class="newmessage-insert-item">名前</span>
                  </el-dropdown-item>
                </el-tooltip>
                <el-tooltip placement="right">
                  <div slot="content">
                    インフルエンサーのユーザー名を挿入します。
                  </div>
                  <el-dropdown-item
                    @click.native="InsertParams(accountname_word)"
                  >
                    <span class="newmessage-insert-item">ユーザー名</span>
                  </el-dropdown-item>
                </el-tooltip>
                <el-tooltip placement="right">
                  <div slot="content">
                    DM用宛名を挿入します。<br />DM用宛名の設定が必要です。未設定の場合はユーザー名が挿入されます。
                    <br />[リスト]→[表示項目]→[DM宛名]の表示をオンにすると設定できます。
                  </div>
                  <el-dropdown-item
                    @click.native="InsertParams(personalized_name_word)"
                  >
                    <span class="newmessage-insert-item">DM用宛名</span>
                  </el-dropdown-item>
                </el-tooltip>
                <el-tooltip placement="right">
                  <div slot="content">
                    DM用報酬金額を挿入します。<br />DM用報酬金額の設定が必要です。未設定の場合はブランクとなります。
                    <br />[リスト]→[表示項目]→[DM報酬金額]の表示をオンにすると設定できます。
                  </div>
                  <el-dropdown-item
                    @click.native="InsertParams(personalized_price_word)"
                  >
                    <span class="newmessage-insert-item">DM用報酬金額</span>
                  </el-dropdown-item>
                </el-tooltip>
                <el-tooltip placement="right">
                  <div slot="content">
                    フォロワー数に応じた報酬金額を挿入します。
                  </div>
                  <el-dropdown-item @click.native="cost = true">
                    <span class="newmessage-insert-item"
                      >報酬金額(フォロワー単価)</span
                    >
                  </el-dropdown-item>
                </el-tooltip>
              </el-dropdown-menu>
            </el-dropdown>
            <transition name="fade">
              <div class="data-table-cost-popup top phrase" v-show="cost">
                <div class="inbox-phrase-popup-title">
                  報酬金額をフォロワー単価で設定
                </div>
                <div style="color: #aaa; font-size: 11px">
                  フォロワー数に応じて報酬金額が自動で計算・挿入されます。
                  <br />金額は端数が生じないように100円単位の四捨五入で計算されます。
                </div>
                <div class="data-table-cost-input-unit">
                  <div class="data-table-cost-input-wrap medium">
                    <span style="margin-right: 10px">¥</span>
                    <input
                      type="number"
                      class="data-table-cost-input medium"
                      min="0"
                      step="0.1"
                      v-model="cost_per_unit"
                    />
                  </div>
                  <span
                    style="
                      color: #aaa;
                      margin-left: 10px;
                      font-size: 11px;
                      width: 80%;
                    "
                    >×フォロワー数</span
                  >
                </div>
                <div class="data-table-cost-popup-button">
                  <el-button
                    size="mini"
                    type="default"
                    @click="cancel()"
                    style="width: 40%"
                    >キャンセル</el-button
                  >
                  <el-button
                    size="mini"
                    type="primary"
                    style="width: 60%"
                    @click="insertCost()"
                    >報酬金額を挿入</el-button
                  >
                </div>
              </div>
            </transition>
          </div>
          <div style="position: relative">
            <div
              @click="option_modal = true"
              class="inbox-phrase-option pointer"
              :class="
                send_option.span == 'speedy' ||
                send_option.comment ||
                send_option.mail ||
                send_option.ongoing ||
                send_option.sendable_time_switch
                  ? 'on'
                  : ''
              "
            >
              <font-awesome-icon
                :icon="['far', 'cog']"
                style="margin-right: 3px"
              />送信オプション
            </div>
            <messageOption
              :option_modal.sync="option_modal"
              :referrer="'newmessage'"
            />
          </div>
          <span
            v-if="
              send_option.span == 'speedy' ||
              send_option.comment ||
              send_option.mail ||
              send_option.ongoing ||
              send_option.sendable_time_switch
            "
            class="inbox-phrase-option-on"
            >:オン</span
          >
        </div>
      </div>
      <div class="newmessage-warning left" v-if="spam_risk > 0">
        <div @click="spam_modal = true" class="pointer">
          <font-awesome-icon
            :icon="['fas', 'exclamation-triangle']"
            style="margin-right: 1px"
          />
          スパムとみなされる可能性が高まる懸念事項が{{ spam_risk }}件あります。
        </div>
        <transition name="fade">
          <div class="data-table-cost-popup top spam" v-show="spam_modal">
            <div
              class="newmessage-spam-detail-wrap"
              v-if="send_option.span == 'speedy'"
            >
              <div class="newmessage-spam-detail-title">
                <font-awesome-icon
                  :icon="['fas', 'exclamation-circle']"
                  style="margin-right: 1px"
                />DMの送信間隔
              </div>
              <div class="newmessage-spam-detail-description">
                DMの送信間隔がスピーディ(2~3分間)に設定されています。1時間当たり10件以上、1日あたり50~100件以上のDMを送信するとスパムとみなされる可能性が高まります。
              </div>
            </div>
            <div class="newmessage-spam-detail-wrap" v-if="send_option.comment">
              <div class="newmessage-spam-detail-title">
                <font-awesome-icon
                  :icon="['fas', 'exclamation-circle']"
                  style="margin-right: 1px"
                />コメントオプション
              </div>
              <div class="newmessage-spam-detail-description">
                DMと同時に投稿にコメントを行うオプションがオンになっています。不特定多数の投稿にに連続してコメントを残すとスパムとみなされる可能性が高まります。
              </div>
            </div>
            <div class="newmessage-spam-detail-wrap" v-if="send_option.ongoing">
              <div class="newmessage-spam-detail-title">
                <font-awesome-icon
                  :icon="['fas', 'exclamation-circle']"
                  style="margin-right: 1px"
                />送信続行オプション
              </div>
              <div class="newmessage-spam-detail-description">
                送信規制がかかってしまった後にメッセージを送信し続けると、スパムとみなされ規制が長期化する可能性が高まります。
              </div>
            </div>
            <div class="newmessage-spam-detail-wrap" v-if="url_exist">
              <div class="newmessage-spam-detail-title">
                <font-awesome-icon
                  :icon="['fas', 'exclamation-circle']"
                  style="margin-right: 1px"
                />リンクの挿入
              </div>
              <div class="newmessage-spam-detail-description">
                メッセージにリンクが挿入されています。やりとりを行ったことがないユーザーへの初回メッセージにURL、メールアドレス、メンションタグなどのリンクが含まれているとスパムとみなされる可能性が高くなります。
              </div>
            </div>
            <div
              class="newmessage-spam-detail-wrap"
              v-if="!value.match(this.personalized_regexp) && value_length > 1"
            >
              <div class="newmessage-spam-detail-title">
                <font-awesome-icon
                  :icon="['fas', 'exclamation-circle']"
                  style="margin-right: 1px"
                />パーソナライズワードが未挿入
              </div>
              <div class="newmessage-spam-detail-description">
                パーソナライズワードが未挿入です。同一内容のメッセージを連続して送信すると、スパムとみなされる可能性が高まります。パーソナライズワード（ユーザー名、名前、DM用宛名、報酬金額）を挿入して、メッセージをパーソナライズしてください。
              </div>
            </div>
            <div class="newmessage-spam-detail-description">
              スパムとみなされてしまった場合、DMの送信が一定期間規制される可能性があります。安全にメッセージを送信するには、上記懸念事項の解消を推奨いたします。
            </div>
          </div>
        </transition>
      </div>
      <div class="newmessage-warning" v-if="reel_url_exist">
        <div>
          <font-awesome-icon :icon="['fas', 'exclamation-triangle']" />
          送信メッセージにInstagramのリール投稿URLが含まれます。環境によっては動画のサムネイルのみ表示され、テキストが表示されない場合があります。
        </div>
      </div>
      <div class="newmessage-warning">
        <div v-if="value_length > 900">
          <font-awesome-icon
            :icon="['fas', 'exclamation-triangle']"
          />
          パーソナライズ項目を含め、1000字以内になるようにご注意ください。送信先ごとにプレビューを確認してください。
        </div>
      </div>
      <div class="newmessage-footer">
        <div class="flex-row" style="font-size:10px" v-if="recipient.length > 1">
          <font-awesome-icon :icon="['fal', 'exclamation-circle']" style="margin-right: 3px;" />
          各送信先へのメッセージは
          {{ send_option.span == "speedy" ? "2~3分" : "6~8分" }}程度間隔を空けて送信されます。
        </div>
        <div class="flex-space"></div>
        <div class="inbox-input-length" :class="value_length > 1000 ? 'limit' : ''">{{ value_length }}/1000</div>
        <el-button style="margin-right: 10px;" :disabled="value_length <= 1 || preview_drawer" @click="openPreview(-1)">プレビュー</el-button>
        <el-tooltip :disabled="value_length <= 1000 && recipient.length != 0 && this.value.match(/\S/g) && ig_selected != '' && !ig_selected.login_required && !senderIgAccountLoading">
          <div slot="content">
            <span v-if="recipient.length == 0">
              送信先が選択されていません
              <br />
            </span>
            <span v-if="!this.value.match(/\S/g)">
              メッセージが入力されていません
              <br />
            </span>
            <span v-if="ig_selected == ''">
              送信元が選択されていません
              <br />
            </span>
            <span v-if="ig_selected.login_required">
              送信元アカウントの連携が解除されています
              <br />
            </span>
            <span v-if="senderIgAccountLoading">
              送信元アカウントのステータス確認中です
              <br />
            </span>
            <span v-if="value_length > 1000">
              文字数が上限をオーバーしています
              <br />
            </span>
          </div>
          <span>
            <el-button
              type="primary"
              :disabled="
                value_length > 1000 ||
                recipient.length == 0 ||
                !this.value.match(/\S/g) ||
                ig_selected == '' ||
                ig_selected.login_required ||
                senderIgAccountLoading
              "
              @click="sendConfirm()"
            >
              <div class="flex-row">
                送信
                <div v-if="connectAccountLoading" class="loading-spinner"></div>
                <div class="loader--mini" v-show="send_loading"></div>
              </div>
            </el-button>
          </span>
        </el-tooltip>
      </div>
    </div>

    <!-- cost modal bg -->
    <div class="cost-overlay" v-show="cost || option_modal || spam_modal" @click="(cost = false), (option_modal = false), (spam_modal = false)"></div>

    <messagePreview :preview_drawer.sync="preview_drawer" :minimize="minimize" :message="value" :recipient="recipient" :preview_index="preview_index" :type="'bulk'"/>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const createPhraseAPI = root + "/api/message/create_phrase";
const broadCastBulkAPI = root + "/api/message/broadcast_bulk";
const reelUrlRegex = /(?:https?:\/\/)?(?:www\.)?instagram\.com\/reel\/[A-Za-z0-9_-]+(?:[/?#][^\s]*)?/i;
const urlRegex =
  /((?:https:\/\/)|(?:http:\/\/)|(?:www\.))?([a-zA-Z0-9\-.]+\.[a-zA-Z]{2,3}(?:\??)[a-zA-Z0-9\-._?,'/\\+&%$#=~]+)/g;
import connectAccount from "./connect_account.vue";
import messageOption from "./message_option.vue";
import phraseSelect from "./phrase_select";
import messagePreview from "./message_preview.vue";

export default {
  name: "newmessage",
  components: {
    connectAccount,
    messageOption,
    phraseSelect,
    messagePreview,
  },
  props: [
    "html",
    "checkList",
    "recipient",
    "newmessage_drawer",
    "message_drawer",
  ],
  data() {
    return {
      minimize: false,
      preview_drawer: false,
      preview_index: 0,
      cost: false,
      cost_per_unit: 1,
      option_modal: false,
      spam_modal: false,
      phrase_loading: false,
      phrase_list: [],
      phrase_drawer: false,
      send_loading: false,
      senderIgAccountLoading: false,
      connectAccountLoading: false,
      default_start: "00:00",
      default_end: "24:00",
      title: "",
      new_html: "",
      value: "",
      pos_num: "",
      offset: 0,
      pos_x: 0,
      pos_y: 0,
      name_word: "{{名前}}",
      name_regexp: new RegExp("{{名前}}", "g"),
      accountname_word: "{{ユーザー名}}",
      accountname_regexp: new RegExp("{{ユーザー名}}", "g"),
      personalized_name_word: "{{DM用宛名}}",
      personalized_name_regexp: new RegExp("{{DM用宛名}}", "g"),
      personalized_price_word: "{{DM用報酬金額}}",
      personalized_price_regexp: new RegExp("{{DM用報酬金額}}", "g"),
      cost_former_word: "{{報酬:フォロワー数×",
      cost_former_regexp: new RegExp("{{報酬:フォロワー数×", "g"),
      cost_latter_word: "円}}",
      cost_latter_regexp: new RegExp("円}}", "g"),
      name_params:
        '&#8203;<span contenteditable="false">​&#8203;<span class="inbox-phrase-params-in pointer"><span>{{名前}}</span></span>&#8203;</span>&#8203;',
      accountname_params:
        '&#8203;<span contenteditable="false">​&#8203;<span class="inbox-phrase-params-in pointer"><span>{{ユーザー名}}</span></span>&#8203;</span>&#8203;',
      personalized_name_params:
        '&#8203;<span contenteditable="false">​&#8203;<span class="inbox-phrase-params-in pointer"><span>{{DM用宛名}}</span></span>&#8203;</span>&#8203;',
      personalized_price_params:
        '&#8203;<span contenteditable="false">​&#8203;<span class="inbox-phrase-params-in pointer"><span>{{DM用報酬金額}}</span></span>&#8203;</span>&#8203;',
      cost_former_params:
        '&#8203;<span contenteditable="false">​&#8203;<span class="inbox-phrase-params-in pointer"><span>{{報酬:フォロワー数×',
      cost_latter_params: "円}}</span></span>&#8203;</span>&#8203;",
      personalized_regexp:
        /{{(名前|ユーザー名|DM用宛名|DM用報酬金額)}}|{{報酬:フォロワー数×[0-9.]+円}}/g,
      phrase_select_drawer: false,
      connectAccountCheck: false,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    activate() {
      return this.$store.state.activate;
    },
    admin_mode() {
      return this.$store.state.admin_mode;
    },
    ig_info() {
      return this.$store.state.ig_info;
    },
    ig_selected() {
      return this.$store.state.ig_selected;
    },
    cost_word() {
      return "{{報酬:フォロワー数×" + this.cost_per_unit + "円}}";
    },
    childNodesNum() {
      return document.getElementById("phrase").childNodes.length;
    },
    value_length() {
      var name_num = this.value.match(new RegExp("{{名前}}", "g"));
      var account_name_num = this.value.match(
        new RegExp("{{ユーザー名}}", "g")
      );
      var personalized_name_num = this.value.match(
        new RegExp("{{DM用宛名}}", "g")
      );
      var personalized_price_num = this.value.match(
        new RegExp("{{DM用報酬金額}}", "g")
      );
      var price_num = this.value.match(new RegExp("{{報酬:フォロワー数", "g"));
      if (!name_num && !account_name_num && !price_num) {
        return this.value.length - 1; // 手前で実行される「syncメソッド」で合計数に「+1」しているので、このタイミングで「-1」で差し引く
      } else {
        var length =
          this.value.length +
          (name_num ? 18 * name_num.length : 0) +
          (account_name_num ? 17 * account_name_num.length : 0) +
          (personalized_name_num ? 18 * personalized_name_num.length : 0) +
          (personalized_price_num ? 18 * personalized_price_num.length : 0) +
          (price_num ? 8 * price_num.length : 0);
        return length - 1; // 手前で実行される「syncメソッド」で合計数に「+1」しているので、このタイミングで「-1」で差し引く
      }
    },
    send_option() {
      return this.$store.state.send_option;
    },
    url_exist() {
      var del_strmark_message = this.value.replace(/\{\{.*\}\}/g, ""); //{{}}で囲っているテキストをURL判定しないように空に変換
      if (del_strmark_message.match(urlRegex)) {
        return true;
      } else {
        return false;
      }
    },
    reel_url_exist() {
      return reelUrlRegex.test(this.value);
    },
    spam_risk() {
      var count = 0;
      var del_strmark_message = this.value.replace(/\{\{.*\}\}/g, ""); //{{}}で囲っているテキストをURL判定しないように空に変換
      if (this.send_option.comment) count += 1;
      if (this.send_option.span == "speedy") count += 1;
      if (this.send_option.ongoing) count += 1;
      if (!this.value.match(this.personalized_regexp) && this.value_length > 1)
        count += 1;
      if (del_strmark_message.match(urlRegex)) count += 1;
      return count;
    },
    client_select() {
      return this.$store.state.client_select;
    },
    member_select() {
      return this.$store.state.member_select;
    },
  },
  mounted() {
    this.sync();
    setTimeout(() => {
      this.movePos();
    }, 200);
    // 管理者の場合は一斉送信用アカウントを表示
    if (this.$store.state.admin_mode) {
      const bulk_sender = {
        no: null,
        client_id: 0,
        client_name: this.$store.state.client_name,
        uuid: "",
        phone_id: "",
        device_id: "",
        csrftoken: "",
        sessionid: "",
        ig_id: "",
        account_name: "一斉送信用アカウント",
        password: null,
        name: "",
        profile_picture_url: this.$store.state.img_url,
        login_required: 0,
        token: this.$store.state.token,
        is_single_sender: 0,
        is_bulk_sender: 1,
      };
      this.$store.state.ig_info.unshift(bulk_sender);
    }
  },
  methods: {
    cancel() {
      this.cost = false;
    },
    sync() {
      this.new_html = document.getElementById("phrase").innerHTML;
      var nodes = document.getElementById("phrase").childNodes;
      var value = "";
      var node = "";
      for (let i = 0; i < nodes.length; i++) {
        node = nodes[i].textContent.replace(/\n|<br>/g, "");
        value += node;
        value += "\n";
      }
      this.value = value;
      setTimeout(() => {
        this.getPos();
      }, 100);
    },
    enter() {
      document.execCommand("DefaultParagraphSeparator", false, "p");
    },
    paste(e) {
      var text = e.clipboardData.getData("text/plain");
      document.execCommand("insertText", false, text);
    },
    getPos() {
      if (!document.getElementById("phrase").childNodes[0]) {
        document.execCommand(
          "insertHTML",
          false,
          '<p class="inbox-phrase-block"><br></p>'
        );
      } else {
        var range = window.getSelection();
        // console.log(range);
        var rangeCount = 0;
        var childNodes = document.getElementById("phrase").childNodes;
        var select = window.getSelection();
        var selectedOffsetTop = 0;
        if (select.anchorNode.nodeType == 3) {
          selectedOffsetTop = select.anchorNode.parentNode.offsetTop;
        } else {
          selectedOffsetTop = select.anchorNode.offsetTop;
        }
        this.offset = selectedOffsetTop;
        // console.log(childNodes);
        for (var i = 0; i < childNodes.length; i++) {
          // if (childNodes[i].outerHTML) {
          rangeCount += childNodes[i].outerHTML.length;
          if (childNodes[i].offsetTop == selectedOffsetTop) break;
          // } else if (childNodes[i].nodeType == 3) {
          //   rangeCount += childNodes[i].textContent.length;
          //   if (childNodes[i].parentNode.offsetTop == selectedOffsetTop) break;
          // }
        }
        this.pos_y = i;

        //xを決定
        if (childNodes[i] && childNodes[i].childNodes) {
          if (childNodes[i].childNodes.length <= 1) {
            this.pos_x = range.anchorOffset;
          } else {
            var anchorData = range.anchorNode.data;
            var anchorCount = 0;
            for (let ii = 0; ii < childNodes[i].childNodes.length; ii++) {
              if (childNodes[i].childNodes[ii].nodeType == 3) {
                if (childNodes[i].childNodes[ii].data == anchorData) break;
                anchorCount += childNodes[i].childNodes[ii].length;
              } else if (childNodes[i].childNodes[ii].textContent) {
                if (childNodes[i].childNodes[ii].textContent == anchorData) break;
                anchorCount += childNodes[i].childNodes[ii].textContent.length;
              } else if (childNodes[i].childNodes[ii].wholeText) {
                if (childNodes[i].childNodes[ii].wholeText == anchorData) break;
                anchorCount += childNodes[i].childNodes[ii].wholeText.length;
              }
            }
            this.pos_x = anchorCount + range.anchorOffset;
          }
        }
        this.pos_num = rangeCount + this.pos_x;
      }
    },
    InsertParams(word) {
      var node = document.getElementById("phrase").childNodes[this.pos_y];
      if (!node) {
        var OuterHtml = this.name_params;
      } else {
        var text = node.textContent;
        var before = text.substr(0, this.pos_x);
        var after = text.substr(this.pos_x, text.length);
        OuterHtml =
          '<p class="inbox-phrase-block">' + before + word + after + "<br></p>";
        var html = OuterHtml.replace(
          this.accountname_regexp,
          this.accountname_params
        );
        html = html.replace(this.name_regexp, this.name_params);
        html = html.replace(
          this.personalized_name_regexp,
          this.personalized_name_params
        );
        html = html.replace(
          this.personalized_price_regexp,
          this.personalized_price_params
        );
        html = html.replace(this.cost_former_regexp, this.cost_former_params);
        var NewOuterHtml = html.replace(
          this.cost_latter_regexp,
          this.cost_latter_params
        );
        node.outerHTML = NewOuterHtml;
      }
      setTimeout(() => {
        this.movePos();
      }, 200);
    },
    movePos() {
      var node = document.getElementById("phrase").childNodes[this.pos_y];
      if (!node) {
        node = document.getElementById("phrase");
      }
      var selection = window.getSelection();
      var range = document.createRange();
      range.setStart(
        node,
        node.childNodes.length ? node.childNodes.length : node.length
      );
      range.collapse(true);
      selection.removeAllRanges();
      selection.addRange(range);
    },
    insertCost() {
      this.InsertParams(this.cost_word);
      this.cost = false;
    },
    createPhrase() {
      this.phrase_loading = true;
      var params = new URLSearchParams();
      params.append("phrase_title", this.title);
      params.append("phrase_content", this.value);
      params.append("token", this.token);
      this.axios.post(createPhraseAPI, params).then(() => {
        this.phrase_loading = false;
        this.$emit("closePhrase");
        this.$emit("loadPhrase");
      });
    },
    editPhrase() {
      this.phrase_loading = true;
      var params = new URLSearchParams();
      params.append("phrase_title", this.title);
      params.append("phrase_content", this.value);
      params.append("token", this.token);
      this.axios.post(createPhraseAPI, params).then(() => {
        this.phrase_loading = false;
        this.$emit("closePhrase");
        this.$emit("loadPhrase");
      });
    },
    deleteInfluencer(index, ig_id) {
      this.recipient.splice(index, 1); //送信先から選択した要素を削除
      if (index < this.preview_index) {
        this.preview_index = Math.max(this.preview_index - 1, 0); //削除した要素がプレビュー先の場合、プレビュー先を1つ前にする。新しいプレビュー先がマイナスにならないように調整
      }
      if ((index == this.preview_index) && (index == this.recipient.length)) {
        this.preview_index = Math.max(this.preview_index - 1, 0); //削除した要素が最後尾かつプレビュー先の場合、プレビュー先を1つ前にする。
      }
      for (let i = 0; i < this.checkList.length; i++) {
        if (ig_id == this.checkList[i]) {
          this.checkList.splice(i, 1);
        }
      }
      this.$emit("update:checkList", this.checkList);
    },
    minimizeWindow() {
      this.minimize = !this.minimize;
    },
    closeNewmessage() {
      this.new_html = document.getElementById("phrase").innerHTML;
      this.$emit("update:html", this.new_html);
      this.$emit("update:newmessage_drawer", false);
      this.$emit("closeNewmessage");
    },
    openPhrase() {
      this.phrase_info = [];
      this.phrase_type = "open";
      this.phrase_drawer = true;
    },
    closePhrase() {
      this.phrase_drawer = false;
    },
    insertTemplete(phrase_html) {
      this.$nextTick(() => {
        let regex = /<br>(?!<\/div>)/gi;
        let html = phrase_html.replace(regex, "");
        this.$emit("update:html", html);
        setTimeout(() => {
          this.sync();
          this.movePos();
        }, 200);
      });
      this.phrase_select_drawer = false;
    },
    isIgAccountLoading(value, loaded) {      
      this.senderIgAccountLoading = value;
      this.connectAccountLoading = loaded;
    },
    sendConfirm() {
      if (this.connectAccountCheck) {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: "DM送信が一時的に使用できません。しばらく時間を置いてから行なってください。",
        });
      } else if (this.value_length > 1000) {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: "メッセージが長すぎます",
        });
      } else if (!this.value.match(/\S/g)) {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: "メッセージが入力されていません",
        });
      } else {
        this.$confirm(
          "Instagram上でのスパム回避のため、送信先が複数の場合は各送信先へのメッセージは" +
            (this.send_option.span == "speedy" ? "2~3分" : "6~8分") +
            "程度間隔を空けて送信されます。全員にメッセージ送信が完了するまで一定程度お時間を要します。<br><ul style='list-style: unset; padding:0 0 0 20px; margin: 12px 0 0 0'>" +
            "<li style='list-style:unset'>複数人に連続的にDMを送信すると、Instagram側で一時的にDM規制がかかる場合がございます。本メッセージの送信中に規制がかかった場合、自動で送信が停止されます。</li>" +
            "<li style='list-style:unset'>送信元のInstagramアカウントにDM規制がかかっている状況で送信を実施すると、一時的にロックされたり、最悪の場合アカウントが凍結されてしまう場合があります。</li>" +
            "<li style='list-style:unset'>DM規制がかかっている状態での送信実施はアカウントの安全のためにお控えいただきますようお願い致します。</li></ul>",
          "メッセージを送信してもよろしいですか？",
          {
            confirmButtonText: "送信",
            cancelButtonText: "キャンセル",
            type: "warning",
            dangerouslyUseHTMLString: true,
          }
        )
          .then(() => {
            this.sendMessage();
          })
          .catch(() => {});
      }
    },
    sendMessage() {
      this.send_loading = true;
      var message = this.value;
      message = message.replace(/＠/g, "@"); //全角アットマークがエラーになるため半角に変換
      // var urls = message.match(urlRegex);
      // if (urls instanceof Array) {
      //   var message_type = "link";
      // } else {
      //   message_type = "text";
      // }
      var message_type = "text";
      var params = new URLSearchParams();
      params.append("sessionid", this.ig_selected.sessionid);
      params.append("csrftoken", this.ig_selected.csrftoken);
      params.append("sender_id", this.ig_selected.ig_id);
      params.append("is_bulk_sender", this.ig_selected.is_bulk_sender);
      params.append("recipient_users", JSON.stringify(this.checkList));
      params.append("token", this.token);
      params.append("user_token", this.user_token);
      params.append("message", message);
      params.append("message_type", message_type);
      params.append("option_span", this.send_option.span);
      params.append("option_comment", this.send_option.comment);
      params.append(
        "option_comment_text",
        this.send_option.comment ? this.send_option.comment_text : ""
      );
      params.append("option_mail", this.send_option.mail);
      params.append("option_ongoing", this.send_option.ongoing);
      params.append(
        "option_ongoing_type",
        this.send_option.ongoing ? this.send_option.ongoing_type : ""
      );
      params.append(
        "option_ongoing_date",
        this.send_option.ongoing && this.send_option.ongoing_type == "later"
          ? this.send_option.ongoing_date
          : ""
      );
      params.append(
        "option_ongoing_time",
        this.send_option.ongoing && this.send_option.ongoing_type == "later"
          ? this.send_option.ongoing_time
          : ""
      );
      params.append(
        "option_sendable_time",
        this.send_option.sendable_time_switch
          ? this.send_option.sendable_time_start +
              "-" +
              this.send_option.sendable_time_end
          : "00:00-24:00"
      );
      // params.append("urls", JSON.stringify(urls));
      this.axios
        .post(broadCastBulkAPI, params)
        .then((response) => {
          if (response.data.status == "ok") {
            this.html = "";
            this.value = "";
            this.$emit("clearList");
            this.$alert(
              "メッセージの送信状況は「ダイレクトメッセージ」→「一斉送信リスト」よりご確認いただけます。",
              "メッセージの送信を開始しました",
              {
                confirmButtonText: "OK",
                showCancelButton: false,
                type: "success",
              }
            );
            this.send_loading = false;
            this.newmessage_drawer = false;
            this.$emit("closeNewmessage");
          } else {
            const apiMessage =
              response.data &&
              response.data.message &&
              String(response.data.message).trim();
            const alertBody = apiMessage
              ? apiMessage
              : "メッセージ送信の失敗が続く場合、お手数ですが担当者にお問い合わせください。";
            this.$alert(alertBody, "メッセージの送信に失敗しました", {
              confirmButtonText: "OK",
              showCancelButton: false,
              type: "warning",
            });
            this.send_loading = false;
          }
        })
        .catch(() => {
          this.$confirm(
            "時間を空けて再度お試しください",
            "メッセージが送信できませんでした。",
            {
              confirmButtonText: "OK",
              showCancelButton: false,
              type: "warning",
            }
          );
          this.send_loading = false;
        });
    },
    toConnectSetting() {
      this.$router.push({
        name: "message",
        query: { activeName: "connect" },
      });
    },
    selectMember(member) {
      this.$store.dispatch("selectMember", member);
      this.phrase_list = [];
      this.loadPhrase(true);
    },
    selectClient(client) {
      this.$store.dispatch("selectClient", client);
      this.phrase_list = [];
      this.loadPhrase(true);
    },
    openPreview(index) {
      if (index >= 0) {
        this.preview_drawer = true;
        this.preview_index = index;
      } else {
        this.preview_drawer = !this.preview_drawer;
        if (!this.preview_index) this.preview_index = 0;
      }
    },
    handleConnectAccountError(error) {
      this.connectAccountCheck = !!error;
    },
  },
  filters: {},
  watch: {
    newmessage_drawer() {
      if (this.newmessage_drawer == false) {
        this.$emit("closeNewmessage");
      }
      if (this.newmessage_drawer == true) {
        setTimeout(() => {
          this.sync();
        }, 3000);
      }
    },
  },
};
</script>
